import { SelectOption } from "../control/types";
import {
  MultiValue,
  OnChangeValue,
  Options,
  PropsValue,
  SingleValue,
} from "./types";

export function valueTernary<
  Option extends SelectOption = SelectOption,
  IsMulti extends boolean = boolean,
>(
  isMulti: IsMulti | undefined,
  multiValue: MultiValue<Option>,
  singleValue: SingleValue<Option>
): OnChangeValue<Option, IsMulti> {
  return (isMulti ? multiValue : singleValue) as OnChangeValue<Option, IsMulti>;
}

export function singleValueAsValue<
  Option extends SelectOption = SelectOption,
  IsMulti extends boolean = boolean,
>(singleValue: SingleValue<Option>): OnChangeValue<Option, IsMulti> {
  return singleValue as OnChangeValue<Option, IsMulti>;
}

export function multiValueAsValue<
  Option extends SelectOption = SelectOption,
  IsMulti extends boolean = boolean,
>(multiValue: MultiValue<Option>): OnChangeValue<Option, IsMulti> {
  return multiValue as OnChangeValue<Option, IsMulti>;
}

export function cleanValue<Option extends SelectOption = SelectOption>(
  value: PropsValue<Option> | undefined
): Options<Option> {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === "object" && value !== null) return [value] as Option[];
  return [];
}

export function setValue<Option extends SelectOption = SelectOption>(
  values: Options<Option>,
  newValue: Option,
  isMulti: boolean | undefined
): Options<Option> {
  if (!isMulti) return [newValue];

  const index = values.findIndex((value) => value.id === newValue.id);
  if (index === -1) return [...values, newValue];

  const newValues = values.slice();
  newValues.splice(index, 1);
  return newValues;
}
